module.exports = __webpack_public_path__ + "static/media/img-default.d421a248.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-default.png
// module id = 184
// module chunks = 0